module.exports = __webpack_public_path__ + "img/plate01_08.6795818f.png";